/* SORAI STUDIOS — Product JS: gallery, variants, accordion, sticky ATC, AJAX cart */
document.addEventListener('DOMContentLoaded', function() {

  // HEADER HEIGHT → CSS var so gallery sticky offset is always correct
  (function() {
    var h = document.querySelector('sticky-header') || document.querySelector('.header-wrapper') || document.querySelector('header');
    if (h) document.documentElement.style.setProperty('--sorai-header-h', h.getBoundingClientRect().height + 'px');
  })();

  // GALLERY — supports metal filtering (data-metal on slides/thumbs) + progress bar
  const track = document.getElementById('soraiGalleryTrack');
  if (track) {
    let cur = 0;
    const slides = Array.from(track.querySelectorAll('.sorai-gallery__slide'));
    const thumbs = Array.from(document.querySelectorAll('.sorai-gallery__thumb'));
    const dots = Array.from(document.querySelectorAll('.sorai-gallery__dot'));
    const progressFill = document.getElementById('soraiGalleryProgressFill');
    function isDesktop() { return window.innerWidth >= 769; }
    function visSlides() { return slides.filter(s => !s.classList.contains('is-hidden')); }
    function visThumbs() { return thumbs.filter(t => !t.classList.contains('is-hidden')); }

    function paint() {
      const v = visSlides(), vt = visThumbs(), total = v.length;
      vt.forEach((t, i) => t.classList.toggle('active', i === cur));
      dots.forEach((d, i) => d.classList.toggle('active', i === cur));
      if (progressFill && total > 0) progressFill.style.transform = 'scaleX(' + ((cur + 1) / total) + ')';
    }

    function goTo(i, opts) {
      opts = opts || {};
      const v = visSlides(), total = v.length;
      if (!total) return;
      cur = ((i % total) + total) % total;
      if (isDesktop()) {
        if (!opts.noScroll) {
          const hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sorai-header-h')) || 60;
          const top = v[cur].getBoundingClientRect().top + window.scrollY - hh;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      } else {
        // native scroll-snap owns motion; just set position, let snap settle it
        var target = v[cur];
        if (target) target.scrollIntoView({ behavior: opts.instant ? 'auto' : 'smooth', inline: 'start', block: 'nearest' });
      }
      paint();
    }
    window.soraiGoTo = goTo;

    // Filter gallery to a metal ('gold' | 'silver' | '' for all). Untagged media always shows.
    window.soraiFilterGallery = function (metal, opts) {
      metal = (metal || '').toLowerCase();
      let any = false;
      slides.forEach(s => {
        const m = (s.dataset.metal || '').toLowerCase();
        if (metal && m && m === metal) any = true;
      });
      // Only filter if at least one slide is tagged with the requested metal
      slides.forEach(s => {
        const m = (s.dataset.metal || '').toLowerCase();
        s.classList.toggle('is-hidden', !!(any && metal && m && m !== metal));
      });
      thumbs.forEach(t => {
        const m = (t.dataset.metal || '').toLowerCase();
        t.classList.toggle('is-hidden', !!(any && metal && m && m !== metal));
      });
      cur = 0;
      track.style.transform = '';
      if (!isDesktop()) track.scrollTo({ left: 0, behavior: 'auto' });
      paint();
    };

    document.getElementById('soraiGalleryPrev')?.addEventListener('click', () => goTo(cur - 1));
    document.getElementById('soraiGalleryNext')?.addEventListener('click', () => goTo(cur + 1));
    dots.forEach(d => d.addEventListener('click', () => goTo(+d.dataset.index)));
    thumbs.forEach(t => t.addEventListener('click', function () {
      const idx = visThumbs().indexOf(this);
      if (idx > -1) goTo(idx);
    }));

    // Mobile: continuous native scroll; track position drives the progress bar
    let scrollRaf = null;
    track.addEventListener('scroll', () => {
      if (isDesktop()) return;
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(() => {
        scrollRaf = null;
        const w = track.clientWidth;
        if (w > 0) {
          const idx = Math.round(track.scrollLeft / w);
          if (idx !== cur) { cur = idx; paint(); }
        }
      });
    }, { passive: true });

    // Desktop: sync active thumb + progress while scrolling the stacked gallery
    if ('IntersectionObserver' in window) {
      const visible = new Set();
      const slideObs = new IntersectionObserver(entries => {
        if (!isDesktop()) return;
        entries.forEach(entry => {
          const idx = visSlides().indexOf(entry.target);
          if (idx < 0) return;
          if (entry.isIntersecting) visible.add(idx); else visible.delete(idx);
        });
        if (visible.size > 0) {
          cur = Math.min(...visible);
          paint();
        }
      }, { threshold: 0.1 });
      slides.forEach(s => slideObs.observe(s));
    }

    // Initial state: if a metal variant is preselected, filter to it
    (function () {
      const active = document.querySelector('.sorai-var-btn.active');
      const val = active ? (active.dataset.value || '').toLowerCase() : '';
      if (val === 'gold' || val === 'silver') window.soraiFilterGallery(val, { initial: true });
      else paint();
    })();
  }

  // VARIANT SELECTOR
  const varBtns = document.querySelectorAll('.sorai-var-btn');
  const varInput = document.querySelector('input[name="id"]');
  const priceEl = document.getElementById('soraiPrice');
  const stockEl = document.getElementById('soraiStockSignal');
  const atcBtn = document.getElementById('soraiAtcBtn');
  const stickyName = document.getElementById('soraiStickyName');
  const stickyPrice = document.getElementById('soraiStickyPrice');
  const variants = window.soraiVariants || [];

  function applyVariant(btn) {
    const pos = btn.dataset.optionPosition;
    document.querySelectorAll(`.sorai-var-btn[data-option-position="${pos}"]`).forEach(b => { b.classList.remove('active'); b.setAttribute('aria-pressed','false'); });
    btn.classList.add('active'); btn.setAttribute('aria-pressed','true');
    // update the visible "— Gold/Silver" label
    const selLabel = document.getElementById('soraiOptSel' + pos);
    if (selLabel) selLabel.textContent = btn.dataset.value;
    const sel = {};
    document.querySelectorAll('.sorai-var-btn.active').forEach(b => { sel[b.dataset.optionPosition] = b.dataset.value; });
    const metalVal = (btn.dataset.value || '').toLowerCase();
    if ((metalVal === 'gold' || metalVal === 'silver') && window.soraiFilterGallery) window.soraiFilterGallery(metalVal);
    const match = variants.find(v => Object.entries(sel).every(([p,val]) => v[`option${p}`] === val));
    if (match) {
      if (varInput) varInput.value = match.id;
      const formatted = '$' + (match.price / 100).toFixed(0);
      if (priceEl) priceEl.textContent = formatted;
      if (stickyPrice) stickyPrice.textContent = formatted;
      const headline = document.querySelector('.sorai-prod-headline');
      if (stickyName && headline) stickyName.textContent = headline.textContent.trim() + ', ' + Object.values(sel).join(' / ');
      if (atcBtn) { atcBtn.disabled = !match.available; atcBtn.textContent = match.available ? atcBtn.dataset.label : 'Sold Out'; }
      if (stockEl) { stockEl.style.display = 'none'; } // never show fake-scarcity counts
    }
    return match;
  }

  varBtns.forEach(btn => btn.addEventListener('click', () => applyVariant(btn)));

  // On load: sync the ATC/price to the actually-selected variant so a stale
  // server-rendered "Sold Out" can never persist when the variant is in stock.
  (function syncOnLoad() {
    const params = new URLSearchParams(window.location.search);
    const vid = parseInt(params.get('variant'), 10);
    if (vid && varBtns.length) {
      const target = variants.find(v => v.id === vid);
      if (target) {
        Object.keys(target).forEach(k => {
          const m = k.match(/^option(\d+)$/);
          if (!m) return;
          const btn = Array.from(varBtns).find(b => b.dataset.optionPosition === m[1] && b.dataset.value === target[k]);
          if (btn) applyVariant(btn);
        });
        return;
      }
    }
    const active = document.querySelector('.sorai-var-btn.active');
    if (active) { applyVariant(active); }
    else if (variants.length === 1 && atcBtn) {
      atcBtn.disabled = !variants[0].available;
      atcBtn.textContent = variants[0].available ? atcBtn.dataset.label : 'Sold Out';
    }
  })();

  // ACCORDION
  document.querySelectorAll('.sorai-acc-trigger').forEach(t => {
    t.addEventListener('click', () => {
      const item = t.closest('.sorai-acc-item');
      const open = item.classList.contains('open');
      document.querySelectorAll('.sorai-acc-item').forEach(i => { i.classList.remove('open'); i.querySelector('.sorai-acc-trigger')?.setAttribute('aria-expanded','false'); });
      if (!open) { item.classList.add('open'); t.setAttribute('aria-expanded','true'); }
    });
  });

  // STICKY ATC — appears only after the price has scrolled ABOVE the viewport
  // (i.e. the shopper has scrolled down past the price), never on initial load.
  const stickyBar = document.getElementById('soraiStickyBar');
  const priceAnchor = document.getElementById('soraiPrice');
  if (priceAnchor && stickyBar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(entries) {
      const e = entries[0];
      // show only when price is gone AND it scrolled off the TOP (top < 0),
      // not when it's still below the fold before you've reached it
      const scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
      stickyBar.classList.toggle('sorai-sticky--visible', scrolledPast);
    }, {threshold:0}).observe(priceAnchor);
  }
  // Sticky button triggers the real ATC form
  const stickyBtn = document.getElementById('soraiStickyBtn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function() {
      const form = document.getElementById('soraiAtcForm');
      if (form) form.requestSubmit ? form.requestSubmit() : form.querySelector('.sorai-atc-btn').click();
    });
  }

  // AJAX CART
  const atcForm = document.getElementById('soraiAtcForm');
  if (atcForm) {
    atcForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // Prevent Dawn or other scripts from also handling this
      const btn = atcForm.querySelector('.sorai-atc-btn');
      if (!btn || btn.disabled) return;
      const orig = btn.textContent.trim();
      btn.textContent = 'Adding…'; btn.disabled = true;
      try {
        const id = atcForm.querySelector('input[name="id"]')?.value;
        const qty = parseInt(atcForm.querySelector('input[name="quantity"]')?.value) || 1;
        if (!id) throw new Error('No variant selected');
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
          body: JSON.stringify({id: parseInt(id), quantity: qty})
        });
        if (res.ok) {
          btn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          fetch('/cart.js').then(r=>r.json()).then(c => {
            document.querySelectorAll('.sorai-nav__bag-count, .cart-count-bubble span:not(.visually-hidden)').forEach(el => el.textContent = c.item_count);
          });
          setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2200);
        } else {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.description || 'Error');
        }
      } catch(err) {
        btn.textContent = 'Try again';
        setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000);
      }
    });
  }

  // STICKY ATC btn — click the real ATC button rather than dispatching a synthetic event
  document.getElementById('soraiStickyAtcBtn')?.addEventListener('click', function() {
    const mainBtn = document.getElementById('soraiAtcBtn');
    if (mainBtn && !mainBtn.disabled) mainBtn.click();
  });

  // COLLECTION FILTER
  document.querySelectorAll('.sorai-filter-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('.sorai-filter-tab').forEach(t => { t.classList.remove('active'); t.setAttribute('aria-selected','false'); });
      tab.classList.add('active'); tab.setAttribute('aria-selected','true');
      const f = tab.dataset.filter; let count = 0;
      document.querySelectorAll('.sorai-prod-card').forEach(card => { const show = f==='all'||card.dataset.type===f; card.style.display=show?'':'none'; if(show)count++; });
      const lbl = document.querySelector('.sorai-filter-count-label'); if(lbl) lbl.textContent = count+' product'+(count!==1?'s':'');
    });
  });

  // EMAIL FORM
  document.querySelector('.sorai-email__form')?.addEventListener('submit', e => {
    e.preventDefault(); const btn = e.target.querySelector('.sorai-email__btn'); const orig = btn.textContent; btn.textContent = 'Subscribed ✓'; setTimeout(()=>{btn.textContent=orig;},3000);
  });

  // QUICK ADD on collection
  window.soraiQuickAdd = async (variantId, btn) => {
    const orig = btn.textContent; btn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:variantId,quantity:1})});
      if (res.ok) { btn.textContent='Added ✓'; document.dispatchEvent(new CustomEvent('cart:refresh')); fetch('/cart.js').then(r=>r.json()).then(c=>{document.querySelectorAll('.cart-count-bubble span:not(.visually-hidden)').forEach(el=>el.textContent=c.item_count);}); setTimeout(()=>{btn.textContent=orig;},2000); }
      else throw new Error();
    } catch { btn.textContent='Error'; setTimeout(()=>{btn.textContent=orig;},2000); }
  };

  // SCROLL REVEAL — auto-tag major PDP sections and reveal on enter
  (function(){
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ids = ['sorai-pdp-wrap'];
    var sel = [
      '.sorai-difference-section .s-diff__inner',
      '.sorai-mission-section .smission__inner',
      '.sorai-image-band-section .s-imgband',
      '.sorai-xsell-section .s-xsell__inner',
      '#shopify-section-template--* .sfaq__inner'
    ];
    var nodes = [];
    document.querySelectorAll('.s-diff__inner, .smission__inner, .s-imgband, .s-xsell__inner, .sfaq__inner, .sorai-material-slider, .wsl-track').forEach(function(n){
      n.classList.add('sorai-reveal'); nodes.push(n);
    });
    document.querySelectorAll('.s-diff__cols, .sfaq__list').forEach(function(n){
      n.classList.add('sorai-reveal-stagger'); nodes.push(n);
    });
    if (!('IntersectionObserver' in window) || !nodes.length) { nodes.forEach(function(n){n.classList.add('is-in');}); return; }
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); obs.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    nodes.forEach(function(n){ obs.observe(n); });
  })();

  // Description read-more (keeps buy box tight)
  (function(){
    var desc = document.getElementById('soraiDesc');
    var btn = document.getElementById('soraiDescToggle');
    if (!desc || !btn) return;
    if (desc.scrollHeight <= desc.clientHeight + 4) { btn.style.display = 'none'; desc.classList.remove('sorai-desc-collapsed'); return; }
    btn.addEventListener('click', function(){
      var open = desc.classList.toggle('is-open');
      btn.textContent = open ? 'Read less' : 'Read more';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  })();
});
